import { Box } from '@mui/material';
import './markdown-overrides.css';
import ReactMarkdown from 'react-markdown';

interface MarkdownDisplayProps {
    markdown: string;
}

const MarkdownDisplay = ({ markdown }: MarkdownDisplayProps) => {
    if (!markdown) {
        return null;
    }

    // Replace en dash bullets (–) with hyphen (-) for markdown list syntax
    markdown = markdown.replace(/–\s/g, '- ');

    return (
        <Box className="markdown" sx={{ width: '100%', maxWidth: '1460px' }}>
            <ReactMarkdown>{markdown}</ReactMarkdown>
        </Box>
    );
};

export { MarkdownDisplay };
